import request from '@/utils/requestV2'
const qs = require('qs')

// 获取资源位置
export function getPositions (data) {
  return request({
    url: '/ooh-product/v1/resource/getresourcepositions',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 资源分页数据
export function getLmResourcePage (data) {
  return request({
    url: '/ooh-product/v1/resource/getlmresourcepage',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 修改资源状态
export function updateResourceStatus (data) {
  return request({
    url: '/ooh-product/v1/resource/updateresourcestatus',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 资源状态历史数据
export function getResourceHistoryPage (data) {
  return request({
    url: '/ooh-product/v1/resource/getresourcehistorypage',
    method: 'POST',
    data: qs.stringify(data)
  })
}
// 获取设备故障统计
export function getTerminalStatistic (data) {
  return request({
    url: '/ooh-product/v1/resource/getterminalstatistic',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 设备分页数据
export function getTerminalList (data) {
  return request({
    url: '/ooh-product/v1/resource/getterminallist',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 获取对应的材质工艺可选项
export function getMakeinfoList (data) {
  return request({
    url: '/ooh-product/v1/resource/getmakeinfolist',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 新增媒介资源
export function saveResource (data) {
  return request({
    url: '/ooh-product/v1/resourceedit/saveresource',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 修改媒介资源
export function updateResource (data) {
  return request({
    url: '/ooh-product/v1/resourceedit/updateResource',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 资源示例图
export function getResourceImg (data) {
  return request({
    url: '/ooh-product/v1/resource/getresourceimg',
    method: 'POST',
    data: qs.stringify(data)
  })
}

// 获取资源类型
export function getResourceTypes (data) {
  return request({
    url: '/ooh-product/v1/resourceedit/getresourcetypes',
    method: 'POST',
    data: qs.stringify(data)
  })
}

/**
 * 新增或修改
 * @param {Object} data
 * @returns
 */
export function submit (data) {
  return request.post('/ooh-product/v1/resource/submit', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

/**
 * 资源分页数据
 * @param {Object} data
 * @returns
 */
export function getResourcePage (data) {
  return request.post('/ooh-product/v1/resource/getresourcepage', qs.stringify(data))
}

/**
 * 删除资源
 * @param {Object} data
 * @returns
 */
export function deleteResource (data) {
  return request.post('/ooh-product/v1/resource/delete', qs.stringify(data))
}

/**
 * 冻结/解冻资源
 * @param {Object} data
 * @returns
 */
export function freezeResource (data) {
  return request.post('/ooh-product/v1/resource/freeze', qs.stringify(data))
}

/**
 * 批量开放二级市场
 * @param {Object} data
 * @returns
 */
export function setOpen (data) {
  return request.post('/ooh-product/v1/resource/setOpen', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

/**
 * 导入excel资源清单
 * @param param FormData
 * @returns ResponseDTO
 */
export function imporResourcetExcel (param) {
  return request.post('/ooh-product/v1/resource/importexcel', param, { timeout: 60000 })
}

/**
 * 获取项目下资源组合包
 * @param data
 * @returns ResponseDTO
 */
export function getPackageList (data) {
  return request.post('/ooh-product/v1/resource/getPackageList', qs.stringify(data))
}

/**
 * 获取公司下资源组合包
 * @param param
 * @returns ResponseDTO
 */
export function getCompanyPackageList (data) {
  return request.post('/ooh-product/v1/resource/getCompanyPackageList', qs.stringify(data))
}

/**
 * 新增资源组合包
 * @param data
 * @returns ResponseDTO
 */
export function savePackage (data) {
  return request.post('/ooh-product/v1/resource/savePackage', qs.stringify(data))
}

/**
 * 更新公司下资源组合包
 * @param data
 * @returns ResponseDTO
 */
export function updateCompanyPackage (data) {
  return request.post('/ooh-product/v1/resource/updateCompanyPackage', qs.stringify(data))
}

/**
 * 更新资源组合包
 * @param data
 * @returns ResponseDTO
 */
export function updatePackage (data) {
  return request.post('/ooh-product/v1/resource/updatePackage', qs.stringify(data))
}

/**
 * 发起导出资源列表
 * @param param query
 * @returns
 */
export function startExportResource (data) {
  return request.post('/ooh-product/v1/resource/startExportResource', qs.stringify(data))
}

/**
 * 获取组合资源列表
 * @param data
 * @returns ResponseDTO
 */
export function getComPage (data) {
  return request.post('/ooh-product/v1/resource/getComPage', qs.stringify(data))
}

/**
 * 获取组合资源下的资源明细
 * @param data
 * @returns ResponseDTO
 */
export function getComResource (data) {
  return request.post('/ooh-product/v1/resource/getComResource', qs.stringify(data))
}

/**
 * 新增或修改
 * @param {Object} data
 * @returns
 */
export function submitCom (data) {
  return request.post('/ooh-product/v1/resource/submitCom', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

/**
 * 资源包资源列表
 * @param {Object} data
 * @returns
 */
export function getPackageResources (data) {
  return request.post('/ooh-product/v1/resource/getPackageResources', qs.stringify(data))
}

/**
 * 资源包新增资源
 * @param {Object} data
 * @returns
 */
export function addPackageResource (data) {
  return request.post('/ooh-product/v1/resource/addPackageResource', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

/**
 * 资源包更新资源
 * @param {Object} data
 * @returns
 */
export function updatePackageResource (data) {
  return request.post('/ooh-product/v1/resource/updatePackageResource', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

/**
 * 资源包删除资源
 * @param {Object} data
 * @returns
 */
export function deletePackageResource (data) {
  return request.post('/ooh-product/v1/resource/deletePackageResource', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

/**
 * 获取资源变更记录
 * @param {Object} data
 * @returns
 */
export function getHistory (data) {
  return request.post('/ooh-product/v1/resource/getHistory', qs.stringify(data))
}

/**
 * 获取资源导入记录
 * @param {Object} data
 * @returns
 */
export function getImport (data) {
  return request.post('/ooh-product/v1/resource/getImport', qs.stringify(data))
}

/**
 * 批量更新资源包资源
 * @param {Object} data
 * @returns
 */
export function updatePackageResources (data) {
  return request.post('/ooh-product/v1/resource/updatePackageResources', data, {
    headers: {
      'content-type': 'application/json'
    }
  })
}

/**
 * 删除组合资源下的资源
 * @param data
 * @returns
 */
export function deleteComResource (data) {
  return request.post('/ooh-product/v1/resource/deleteComResource', qs.stringify(data))
}

/**
 * 添加组合资源下的资源
 * @param data
 * @returns
 */
export function addComResource (data) {
  return request.post('/ooh-product/v1/resource/addComResource', qs.stringify(data))
}

/**
 * 更新组合资源下的资源规格
 * @param data
 * @returns
 */
export function updateComResource (data) {
  return request.post('/ooh-product/v1/resource/updateComResource', qs.stringify(data))
}
